import axios from "axios";

const postClinicEmployee = async (baseUrl, token, doctorId, employee) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let postResponse = null

    await axios.post(baseUrl + "/doctor/" + doctorId + "/employee", employee, config)
        .then((res) => {
            postResponse = {
                status: res.data.status,
                data: res.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                postResponse = {
                    status: error.response.status,
                    data: error.response.status
                }
            }
        });
    return postResponse
}

export default postClinicEmployee;